/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Err_Email_InvalidInputs */

const es_footer_err_email_invalid = /** @type {(inputs: Footer_Err_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce un email válido.`)
};

const gl_footer_err_email_invalid = /** @type {(inputs: Footer_Err_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce un correo válido.`)
};

const en_footer_err_email_invalid = /** @type {(inputs: Footer_Err_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a valid email address.`)
};

/**
* | output |
* | --- |
* | "Enter a valid email address." |
*
* @param {Footer_Err_Email_InvalidInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const footer_err_email_invalid = /** @type {((inputs?: Footer_Err_Email_InvalidInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Err_Email_InvalidInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_footer_err_email_invalid(inputs)
	if (locale === "en") return en_footer_err_email_invalid(inputs)
	return es_footer_err_email_invalid(inputs)
});